import { signInWithGoogle } from '../lib/supabase'
import { useState } from 'react'

export default function LoginPage({ denied }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  async function handleLogin() {
    setLoading(true)
    setError(null)
    try {
      await signInWithGoogle()
    } catch (e) {
      setError('Sign-in failed. Please try again.')
      setLoading(false)
    }
  }

  return (
    <div style={styles.root}>
      <div style={styles.card}>
        <div style={styles.logo}>AI<span style={styles.zero}>0</span></div>
        <h1 style={styles.title}>AllInOne</h1>
        <p style={styles.sub}>Your personal suite. Sign in to continue.</p>

        {denied && (
          <div style={styles.error}>
            ⛔ This Google account is not authorised to access AI0.
          </div>
        )}
        {error && <div style={styles.error}>{error}</div>}

        <button style={styles.btn} onClick={handleLogin} disabled={loading}>
          <GoogleIcon />
          {loading ? 'Redirecting...' : 'Sign in with Google'}
        </button>

        <p style={styles.hint}>Access is restricted to authorised accounts only.</p>
      </div>
    </div>
  )
}

function GoogleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" style={{ marginRight: 10 }}>
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
    </svg>
  )
}

const styles = {
  root: {
    minHeight: '100vh',
    background: '#0a0a0f',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  card: {
    background: '#13131a',
    border: '1px solid #2a2a3a',
    borderRadius: 20,
    padding: '48px 40px',
    width: '100%',
    maxWidth: 400,
    textAlign: 'center',
    boxShadow: '0 0 60px rgba(99,102,241,0.08)',
  },
  logo: {
    fontSize: 52,
    fontWeight: 900,
    color: '#fff',
    letterSpacing: -2,
    lineHeight: 1,
    marginBottom: 8,
  },
  zero: {
    color: '#6366f1',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: '#a0a0b0',
    marginBottom: 8,
    letterSpacing: 3,
    textTransform: 'uppercase',
  },
  sub: {
    fontSize: 14,
    color: '#555570',
    marginBottom: 32,
  },
  btn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '13px 20px',
    background: '#fff',
    color: '#1a1a2e',
    border: 'none',
    borderRadius: 10,
    fontSize: 15,
    fontWeight: 600,
    cursor: 'pointer',
    marginBottom: 16,
    transition: 'opacity 0.2s',
  },
  error: {
    background: '#2a1515',
    border: '1px solid #5a2020',
    color: '#ff8080',
    borderRadius: 8,
    padding: '10px 14px',
    fontSize: 13,
    marginBottom: 16,
    textAlign: 'left',
  },
  hint: {
    fontSize: 12,
    color: '#333350',
  }
}
